import { useAppDispatch } from '@store/hooks';
import { useOpenDriverConversationMutation } from '@store/rtk/driverChat';
import {
  openDriverChatDrawer,
  rememberChatDriver,
} from '@store/slices/driverChat/driverChatSlice';
import { toastError } from '@utils/helpers';
import { mergeChatSeed } from '@component/DriverChat/helpers';
import { DriverChatSeed } from '@component/DriverChat/types';

/**
 * Starts (or resumes) the conversation for a segment: POST /conversations,
 * then opens the thread. The drawer only opens once the server has confirmed
 * this dispatcher may chat on the segment.
 */
export const useStartDriverChat = () => {
  const dispatch = useAppDispatch();
  const [openConversation, { isLoading }] = useOpenDriverConversationMutation();

  const start = async (seed: DriverChatSeed) => {
    // Keep the driver's phone/photo from the segment on screen, so the thread
    // still has them when it is reopened later from the panel.
    dispatch(
      rememberChatDriver({
        segmentId: seed.segmentId,
        phone: seed.driverPhone,
        image: seed.driverImage,
      })
    );
    try {
      const conversation = await openConversation(seed.segmentId).unwrap();
      dispatch(
        openDriverChatDrawer({
          ...mergeChatSeed(conversation, seed),
          conversationId: conversation.conversationId,
          conversationStatus: conversation.conversationStatus,
        })
      );
    } catch (error) {
      toastError(error);
    }
  };

  return { start, isStarting: isLoading };
};
